/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Program_Audio_HelpInputs */



/**
* | output |
* | --- |
* | "Leave empty to use project media" |
*
* @param {Audio_Description_Export_Program_Audio_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_program_audio_help = /** @type {((inputs?: Audio_Description_Export_Program_Audio_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Program_Audio_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Laissez vide pour utiliser le média du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lassen Sie dieses Feld leer, um Projektmedien zu verwenden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lasciare vuoto per utilizzare il supporto del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оставьте поле пустым, чтобы использовать медиафайлы проекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Déjelo vacío para utilizar los medios del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("留空以使用项目介质")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトメディアを使用するには空白のままにしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट मीडिया का उपयोग करने के लिए इसे खाली छोड़ दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deixe em branco para usar a mídia do projeto.")
	return /** @type {LocalizedString} */ ("Leave empty to use project media")
});